<template>
  <DashboardHeader title="Online Application">
    <br />
    <br />
    <div
      v-if="applicationInfo != null && (new Date(applicationInfo.start)).setHours(0,0,0,0) > (new Date()).setHours(0,0,0,0)"
    >
      <v-alert type="error" class="mx-8">
        <v-row>
          <h3 class="mx-auto">Applications Closed!</h3>
        </v-row>
      </v-alert>
    </div>
    <div
      v-else-if="applicationInfo != null &&  (new Date(applicationInfo.end)).setHours(0,0,0,0) < (new Date()).setHours(0,0,0,0)"
    >
      <v-alert type="warning" class="mx-8">
        <v-row>
          <h3 class="mx-auto">Applications Not Yet Opened!</h3>
        </v-row>
      </v-alert>
    </div>
    <div
      v-else-if="applicationInfo != null && (new Date(applicationInfo.start)).setHours(0,0,0,0) <= (new Date()).setHours(0,0,0,0) &&  (new Date(applicationInfo.end)).setHours(0,0,0,0) >= (new Date()).setHours(0,0,0,0)"
    >
      <v-stepper v-model="e1">
        <v-stepper-header>
          <v-stepper-step :complete="selectedSchool != null" step="1">Select School</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="selectedSchool != null" step="2">Required Documents</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="step3Complete()" step="3">Personal Details</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step
            :complete="lsAddress != null && lsName!= null && lsYear!= null"
            step="4"
          >Previous School</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="gradeApplyingFor != null" step="5">Application Details</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="step6Complete()" step="6">Parent/Guardian Details</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="step7Complete()" step="7">Learner Medical Information</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="step8Complete()" step="8">Correspondence/Emergency Contact</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="formValidated" step="9">Validate Form</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="step10Complete()" step="10">Upload Required Documents</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="applicationSubmitted" step="11">Submit Application</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-card class="mb-12 mt-12" height="200px">
              <v-text-field class="mx-12 mt-6" readonly v-model="getUserSchool.schname"></v-text-field>
            </v-card>
            <v-btn :color="getThemeColor" style="color:white" @click="e1 = 2">Continue</v-btn>
            <v-btn text @click="goBack()">Back</v-btn>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-card class="mb-12 mt-12">
              <v-list disabled rounded>
                <v-subheader>
                  <h3>The Following Documents must be Scanned, Saved as PDF formats, and be Ready for Uploads</h3>
                  <hr />
                </v-subheader>
                <v-list-item-group :color="getThemeColor" style="color:white" class="mt-4">
                  <v-list-item v-for="(doc, i) in requiredDocs" :key="i+Math.random()">
                    <v-list-item-icon>
                      <v-icon>mdi-checkbox-multiple-marked-circle</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title v-text="doc.text"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
            <v-btn :color="getThemeColor" style="color:white" @click="e1 = 3">Continue</v-btn>
            <v-btn text @click="goBack()">Back</v-btn>
          </v-stepper-content>

          <v-stepper-content step="3">
            <v-card class="mb-12 mt-12">
              <v-form v-model="valid">
                <v-container>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="firstname"
                        :rules="nameRules"
                        :counter="50"
                        label="First Names"
                        required
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="lastname"
                        :rules="nameRules"
                        :counter="30"
                        label="Surname"
                        required
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field v-model="email" :rules="emailRules" label="E-mail" required></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="placeOfBirth"
                        :rules="nameRules"
                        :counter="50"
                        label="Place Of Birth"
                        required
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="dob"
                        :rules="nameRules"
                        :counter="50"
                        label="Date of Birth [YYYY-mm-dd]"
                        required
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="idNumber"
                        :rules="nameRules"
                        label="ID Number"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="4">
                      <v-select v-model="gender" :items="genders" label="Gender" required></v-select>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-textarea
                        v-model="physicalAddress"
                        :rules="nameRules"
                        :counter="200"
                        solo
                        rows="1"
                        name="input-7-4"
                        label="Physical Address"
                        required
                      ></v-textarea>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="learnerCell"
                        :rules="nameRules"
                        label="Cell #"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card>
            <v-btn :color="getThemeColor" style="color:white" @click="e1 = 4">Continue</v-btn>
            <v-btn text @click="goBack()">Back</v-btn>
          </v-stepper-content>

          <v-stepper-content step="4">
            <v-card class="mb-12 mt-12">
              <v-container>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="lsName"
                      :rules="nameRules"
                      label="Last School Attended"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="lsYear"
                      :rules="nameRules"
                      label="Year You Left Last School"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-textarea
                      v-model="lsAddress"
                      :rules="nameRules"
                      :counter="200"
                      solo
                      rows="1"
                      name="input-7-4"
                      label="Last School Physical Address"
                      required
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
            <v-btn :color="getThemeColor" style="color:white" @click="e1 = 5">Continue</v-btn>
            <v-btn text @click="goBack()">Back</v-btn>
          </v-stepper-content>

          <v-stepper-content step="5">
            <v-card class="mb-12 mt-12">
              <v-container>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-select
                      v-model="gradeApplyingFor"
                      :rules="nameRules"
                      label="Grade Applying For"
                      required
                      :items="gaf"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>

            <v-btn :color="getThemeColor" style="color:white" @click="e1 = 6">Continue</v-btn>

            <v-btn text @click="goBack()">Back</v-btn>
          </v-stepper-content>

          <v-stepper-content step="6">
            <v-card class="mb-12 mt-12">
              <v-form v-model="parent">
                <v-container>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="parentFirstname"
                        :rules="nameRules"
                        :counter="50"
                        label="Parent/Guardian First Names"
                        required
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="parentLastname"
                        :rules="nameRules"
                        :counter="30"
                        label="Parent/Guardian Surname"
                        required
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="parentIdNumber"
                        label="Parent/Guardian ID Number"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="parentTel"
                        :rules="nameRules"
                        :counter="50"
                        label="Parent/Guardian Contact Cell"
                        required
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="parentPlaceOfWork"
                        :rules="nameRules"
                        :counter="50"
                        label="Parent/Guardian Place of Work"
                        required
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="parentWorkTel"
                        :rules="nameRules"
                        label="Parent/Guardian Work Tel"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model=" parentEmail"
                        :rules="emailRules"
                        label="Parent/Guardian E-mail"
                        required
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-textarea
                        v-model="parentPhysicalAddress"
                        :rules="nameRules"
                        :counter="200"
                        solo
                        rows="1"
                        name="input-7-4"
                        label="Parent/Guardian Residential Address"
                        required
                      ></v-textarea>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-textarea
                        v-model="parentWorkAddress"
                        rows="1"
                        :counter="200"
                        :rules="nameRules"
                        label="Parent/Guardian Work Address"
                        required
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card>
            <v-btn :color="getThemeColor" style="color:white" @click="e1 = 7">Continue</v-btn>
            <v-btn text @click="goBack()">Back</v-btn>
          </v-stepper-content>

          <v-stepper-content step="7">
            <v-card class="mb-12 mt-12">
              <v-form v-model="medical">
                <v-container>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="medicalAidNumber"
                        :rules="nameRules"
                        :counter="50"
                        label="Medical Aid Number"
                        required
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="medicalAidName"
                        :rules="nameRules"
                        :counter="30"
                        label="Medical Aid Name"
                        required
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="medicalAidMM"
                        :rules="nameRules"
                        label="Medical Aid Main Member"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="doctorName"
                        :rules="nameRules"
                        :counter="50"
                        label="Doctor Name"
                        required
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-textarea
                        v-model="doctorWorkAddress"
                        :rules="nameRules"
                        :counter="200"
                        rows="1"
                        label="Doctor Work Address"
                        required
                      ></v-textarea>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="doctorWorkTel"
                        :rules="nameRules"
                        label="Doctor Work Tel"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="12">
                      <v-textarea
                        v-model="medicalCondition"
                        :rules="nameRules"
                        :counter="400"
                        solo
                        rows="1"
                        name="input-7-4"
                        label="Medical Condition"
                        required
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card>
            <v-btn :color="getThemeColor" style="color:white" @click="e1 = 8">Continue</v-btn>
            <v-btn text @click="goBack()">Back</v-btn>
          </v-stepper-content>

          <v-stepper-content step="8">
            <v-card class="mb-12 mt-12">
              <v-form v-model="emergencyContact">
                <v-container>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="emergencyContactPerson"
                        :rules="nameRules"
                        :counter="50"
                        label="Correspondence/Emergency Contact Person"
                        required
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="emergencyContactPersonHome"
                        :rules="nameRules"
                        :counter="30"
                        label="Correspondence/Emergency Contact Person Home Tel"
                        required
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="emergencyContactPersonWork"
                        :rules="nameRules"
                        label="Correspondence/Emergency Contact Person Work Tel"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="12">
                      <v-text-field
                        v-model="emergencyContactPersonRelationship"
                        :rules="nameRules"
                        :counter="50"
                        label="Correspondence/Emergency Contact Person Relationship"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card>
            <v-btn :color="getThemeColor" style="color:white" @click="e1 = 9">Continue</v-btn>
            <v-btn text @click="goBack()">Back</v-btn>
          </v-stepper-content>

          <v-stepper-content step="9">
            <v-card class="mb-12 mt-12" height="200px">
              <v-btn
                :color="getThemeColor"
                rounded
                style="color:white"
                @click="validateForm()"
              >Validate Form</v-btn>
              <v-sheet
                v-if="formValidated"
                class="mt-4"
                style="color:green"
              >All required Data Succesfully Validated!</v-sheet>
            </v-card>
            <v-btn :color="getThemeColor" style="color:white" @click="e1 = 10">Continue</v-btn>
            <v-btn text @click="goBack()">Back</v-btn>
          </v-stepper-content>

          <v-stepper-content step="10">
            <v-card class="mb-12 mt-12">
              <v-container>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-file-input
                      v-model="progressReportPS"
                      :color="getThemeColor"
                      label="Upload Required PDF Documents"
                      :placeholder="requiredDocs[0].text"
                      prepend-icon="mdi-paperclip"
                      outlined
                      :show-size="1000"
                      accept="application/pdf"
                      @change="getProgressReportPS()"
                    >
                      <template v-slot:selection="{ index, text }">
                        <v-chip
                          :key="index"
                          :color="getThemeColor"
                          dark
                          label
                          small
                        >{{ requiredDocs[0].text }} {{text}}</v-chip>
                      </template>
                    </v-file-input>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-file-input
                      v-model="transferCardPS"
                      :color="getThemeColor"
                      label="Upload Required PDF Documents"
                      :placeholder="requiredDocs[1].text"
                      prepend-icon="mdi-paperclip"
                      outlined
                      :show-size="1000"
                      accept="application/pdf"
                      @change="getTransferCardPS()"
                    >
                      <template v-slot:selection="{ }">
                        <v-chip :color="getThemeColor" dark label small>{{requiredDocs[1].text}}</v-chip>
                      </template>
                    </v-file-input>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-file-input
                      v-model="idDocStu"
                      :color="getThemeColor"
                      label="Upload Required PDF Documents"
                      :placeholder="requiredDocs[2].text"
                      prepend-icon="mdi-paperclip"
                      outlined
                      :show-size="1000"
                      accept="application/pdf"
                      @change="getIdDocStu()"
                    >
                      <template v-slot:selection="{ }">
                        <v-chip :color="getThemeColor" dark label small>{{requiredDocs[2].text}}</v-chip>
                      </template>
                    </v-file-input>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="4">
                    <v-file-input
                      v-model="idDocParent"
                      :color="getThemeColor"
                      label="Upload Required PDF Documents"
                      :placeholder="requiredDocs[3].text"
                      prepend-icon="mdi-paperclip"
                      outlined
                      :show-size="1000"
                      accept="application/pdf"
                      @change="getIdDocParent()"
                    >
                      <template v-slot:selection="{ }">
                        <v-chip :color="getThemeColor" dark label small>{{requiredDocs[3].text}}</v-chip>
                      </template>
                    </v-file-input>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-file-input
                      v-model="proofOfResidence"
                      :color="getThemeColor"
                      label="Upload Required PDF Documents"
                      :placeholder="requiredDocs[4].text"
                      prepend-icon="mdi-paperclip"
                      outlined
                      :show-size="1000"
                      accept="application/pdf"
                      @change="getProofOfResidence()"
                    >
                      <template v-slot:selection="{ }">
                        <v-chip :color="getThemeColor" dark label small>{{ requiredDocs[4].text }}</v-chip>
                      </template>
                    </v-file-input>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-file-input
                      v-model="proofOfPayment"
                      :color="getThemeColor"
                      label="Upload Required PDF Documents"
                      :placeholder="requiredDocs[5].text"
                      prepend-icon="mdi-paperclip"
                      outlined
                      :show-size="1000"
                      accept="application/pdf"
                      @change="getProofOfPayment()"
                    >
                      <template v-slot:selection="{ }">
                        <v-chip :color="getThemeColor" dark label small>{{ requiredDocs[5].text }}</v-chip>
                      </template>
                    </v-file-input>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
            <v-btn :color="getThemeColor" style="color:white" @click="e1 = 11">Continue</v-btn>
            <v-btn text @click="goBack()">Back</v-btn>
          </v-stepper-content>

          <v-stepper-content step="11">
            <v-card class="mb-12 mt-12" height="200px">
              <v-btn
                :color="getThemeColor"
                rounded
                style="color:white"
                @click="submitForm()"
              >Submit Application</v-btn>
              <v-sheet v-if="formSubmitted" class="mt-4" style="color:green">
                Application Succesfully Submitted!
                <br />
                <h4>Check regularly on your dashboard for application status</h4>
              </v-sheet>
            </v-card>
            <v-btn text @click="goBack()">Back</v-btn>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>
  </DashboardHeader>
</template>

<script>
import DashboardHeader from "../../components/DashboardHeader.vue";
import axios from "../../plugins/axios";
import { mapGetters } from "vuex";

export default {
  computed: mapGetters([
    "getAccessToken",
    "getCurrentUser",
    "getThemeColor",
    "getUserSchool"
  ]),
  components: {
    DashboardHeader
  },
  created() {
    axios
      .getData("/auth/get-application-dates", this.getAccessToken)
      .then(dates => {
        this.applicationInfo = dates;

        this.schools.push({
          text: this.getUserSchool.schname,
          value: this.getUserSchool.emis
        });

        this.learnerCell = this.getCurrentUser.tel;
        const names = this.getCurrentUser.name.split(" ");
        this.firstname = names[0];
        this.lastname = names[names.length - 1];
        this.email = this.getCurrentUser.email;
      });
  },

  data() {
    return {
      applicationInfo: null,
      e1: 1,
      formValidated: false,
      schools: [],
      files: [],
      selectedSchool: true,
      progressReportPS: null,
      transferCardPS: null,
      idDocStu: null,
      idDocParent: null,
      proofOfResidence: null,
      proofOfPayment: null,

      applicationSubmitted: false,
      filesUploaded: false,
      formSubmitted: false,
      gradeApplyingFor: null,
      emergencyContact: null,
      parent: null,
      requiredDocs: [
        { text: "Progress Report From Previous School" },
        { text: "Transfer Card/Letter From Previous School" },
        {
          text:
            "Certified Copy of Identity Document/ Birth Certificate [Student]"
        },
        { text: "Certified Copy of Identity Document [guardian/ parent]" },
        { text: "Proof of Residence" },
        {
          text:
            "Proof of Payment of the Appropriate Non-Refundable Application Fee"
        }
      ],
      gaf: [
        "Grade Pre R",
        "Grade R",
        "Grade 01",
        "Grade 02",
        "Grade 03",
        "Grade 04",
        "Grade 05",
        "Grade 06",
        "Grade 07",
        "Grade 08",
        "Grade 09",
        "Grade 10",
        "Grade 11",
        "Grade 12"
      ],

      emergencyContactPerson: null,
      emergencyContactPersonHome: null,
      emergencyContactPersonWork: null,
      emergencyContactPersonRelationship: null,

      medical: "N/A",
      medicalCondition: "N/A",
      doctorWorkTel: "N/A",
      doctorWorkAddress: "N/A",
      doctorName: "N/A",
      medicalAidMM: "N/A",
      medicalAidName: "N/A",
      medicalAidNumber: "N/A",

      lsYear: null,
      lsName: null,
      lsAddress: null,
      dob: null,
      placeOfBirth: null,
      idNumber: null,
      physicalAddress: null,
      firstname: null,
      lastname: null,
      email: null,

      parentIdNumber: null,
      parentPhysicalAddress: null,
      parentFirstname: null,
      parentLastname: null,
      parentEmail: null,
      parentPlaceOfWork: null,
      parentWorkAddress: null,
      parentTel: null,
      parentWorkTel: null,

      gender: null,
      genders: ["Male", "Female"],

      learnerCell: null,
      valid: false,
      nameRules: [v => !!v || "This Field is required"],
      emailRules: [
        v => !!v || "Valid E-mail is required",
        v => /.+@.+/.test(v) || "E-mail must be valid"
      ]
    };
  },
  methods: {
    goBack() {
      if (this.e1 > 1) {
        this.e1 -= 1;
      } else {
        this.e1 = 11;
      }
    },
    step3Complete() {
      if (
        this.firstname &&
        this.lastname &&
        this.dob &&
        this.idNumber &&
        this.gender
      ) {
        return true;
      } else {
        return false;
      }
    },
    step6Complete() {
      if (
        this.parentIdNumber &&
        this.parentPhysicalAddress &&
        this.parentFirstname &&
        this.parentLastname &&
        this.parentEmail &&
        this.parentPlaceOfWork &&
        this.parentWorkAddress &&
        this.parentTel &&
        this.parentWorkTel
      ) {
        return true;
      } else {
        return false;
      }
    },
    step7Complete() {
      if (
        this.medical != null &&
        this.medicalCondition != null &&
        this.doctorWorkTel != null &&
        this.doctorWorkAddress != null &&
        this.doctorName != null &&
        this.medicalAidMM != null &&
        this.medicalAidName != null &&
        this.medicalAidNumber != null
      ) {
        return true;
      } else {
        return false;
      }
    },
    step8Complete() {
      if (
        this.emergencyContactPerson &&
        this.emergencyContactPersonHome &&
        this.emergencyContactPersonWork &&
        this.emergencyContactPersonRelationship
      ) {
        return true;
      } else {
        return false;
      }
    },
    step10Complete() {
      if (
        this.progressReportPS != null &&
        this.transferCardPS != null &&
        this.idDocStu != null &&
        this.idDocParent != null &&
        this.proofOfResidence != null &&
        this.proofOfPayment != null
      ) {
        return true;
      } else {
        return false;
      }
    },
    validateForm() {
      if (this.selectedSchool != null) {
        if (
          this.lsAddress != null &&
          this.lsName != null &&
          this.lsYear != null
        ) {
          if (this.step3Complete()) {
            if (this.gradeApplyingFor) {
              if (this.step6Complete()) {
                if (this.step7Complete()) {
                  if (this.step8Complete()) {
                    this.formValidated = true;
                    return true;
                  } else {
                    this.e1 = 8;
                    return false;
                  }
                } else {
                  this.e1 = 7;
                  return false;
                }
              } else {
                this.e1 = 6;
                return false;
              }
            } else {
              this.e1 = 5;
              return false;
            }
          } else {
            this.e1 = 4;
            return false;
          }
        } else {
          this.e1 = 3;
          return false;
        }
      } else {
        this.e1 = 1;
        return false;
      }
    },
    getProgressReportPS() {
      if (this.progressReportPS != null && this.progressReportPS != undefined) {
        const reader = new FileReader();
        reader.addEventListener("load", event => {
          this.progressReportPS = event.target.result;
        });
        reader.readAsDataURL(this.progressReportPS);
      }
    },

    getTransferCardPS() {
      if (this.transferCardPS != null && this.transferCardPS != undefined) {
        const reader = new FileReader();
        reader.addEventListener("load", event => {
          this.transferCardPS = event.target.result;
        });
        reader.readAsDataURL(this.transferCardPS);
      }
    },
    getIdDocStu() {
      if (this.idDocStu != null && this.idDocStu != undefined) {
        const reader = new FileReader();
        reader.addEventListener("load", event => {
          this.idDocStu = event.target.result;
        });
        reader.readAsDataURL(this.idDocStu);
      }
    },
    getIdDocParent() {
      if (this.idDocParent != null && this.idDocParent != undefined) {
        const reader = new FileReader();
        reader.addEventListener("load", event => {
          this.idDocParent = event.target.result;
        });
        reader.readAsDataURL(this.idDocParent);
      }
    },
    getProofOfResidence() {
      if (this.proofOfResidence != null && this.proofOfResidence != undefined) {
        const reader = new FileReader();
        reader.addEventListener("load", event => {
          this.proofOfResidence = event.target.result;
        });
        reader.readAsDataURL(this.proofOfResidence);
      }
    },
    getProofOfPayment() {
      if (this.proofOfPayment != null && this.proofOfPayment != undefined) {
        const reader = new FileReader();
        reader.addEventListener("load", event => {
          this.proofOfPayment = event.target.result;
        });
        reader.readAsDataURL(this.proofOfPayment);
      }
    },
    submitForm() {
      const formdata = {
        selectedSchool: this.getUserSchool.emis,
        gradeApplyingFor: this.gradeApplyingFor,
        emergencyContact: this.emergencyContact,
        parent: this.parent,

        emergencyContactPerson: this.emergencyContactPerson,
        emergencyContactPersonHome: this.emergencyContactPersonHome,
        emergencyContactPersonWork: this.emergencyContactPersonWork,
        emergencyContactPersonRelationship: this
          .emergencyContactPersonRelationship,

        medicalCondition: this.medicalCondition,
        doctorWorkTel: this.doctorWorkTel,
        doctorWorkAddress: this.doctorWorkAddress,
        doctorName: this.doctorName,
        medicalAidMM: this.medicalAidMM,
        medicalAidName: this.medicalAidName,
        medicalAidNumber: this.medicalAidNumber,

        lsYear: this.lsYear,
        lsName: this.lsName,
        lsAddress: this.lsAddress,
        dob: this.dob,
        placeOfBirth: this.placeOfBirth,
        idNumber: this.idNumber,
        physicalAddress: this.physicalAddress,
        firstname: this.firstname,
        lastname: this.lastname,
        email: this.email,

        parentIdNumber: this.parentIdNumber,
        parentPhysicalAddress: this.parentPhysicalAddress,
        parentFirstname: this.parentFirstname,
        parentLastname: this.parentLastname,
        parentEmail: this.parentEmail,
        parentPlaceOfWork: this.parentPlaceOfWork,
        parentWorkAddress: this.parentWorkAddress,
        parentTel: this.parentTel,
        parentWorkTel: this.parentWorkTel,

        gender: this.gender,

        learnerCell: this.learnerCell,
        progressReportPS: this.progressReportPS,
        transferCardPS: this.transferCardPS,
        idDocStu: this.idDocStu,
        idDocParent: this.idDocParent,
        proofOfResidence: this.proofOfResidence,
        proofOfPayment: this.proofOfPayment
      };

      axios
        .postDataWithToken(
          "/auth/submit-application",
          formdata,
          this.getAccessToken
        )
        .then(response => {
          this.formSubmitted = true;
        });
    }
  }
};
</script>

<style>
</style>